import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { asPolicyTab, type PolicyTab } from '@/features/ai/ai-href';
import { PolicyDetailPage } from '@/features/ai/agents/agents-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Détail d’une politique : résumé, définition, appels ; révoquer, rétablir. */
export const Route = createFileRoute('/$tenant/agent-policies/$policyId')({
  validateSearch: (search: Record<string, unknown>): { tab: PolicyTab } => ({
    tab: asPolicyTab(search['tab']),
  }),
  component: PolicyDetailRoute,
});

function PolicyDetailRoute() {
  const { tenant, policyId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="agentPolicies"
      crumbs={[{ label: t('nav.items.agentPolicies') }, { label: policyId, mono: true }]}
    >
      <PolicyDetailPage
        tenantId={tenant}
        policyId={policyId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
